import React from "react";
import PropTypes from "prop-types";
import { Message } from "react-message-context";
import { FormRow, PopupHint, ValidInput } from "@op/opds.opux";
import InvalidError from "../InvalidError";
import {
  EMPTY_ERROR_CODE,
  INVALID_TEXT_AREA_ERROR_CODE,
} from "../../../utils/enums";

class TextArea extends React.PureComponent {
  render() {
    const {
      id,
      translations,
      value,
      error,
      rows,
      maxRows,
      maxLength,
      handleOnChange,
      handleOnBlur,
      required,
      counter,
      describedBy,
      popUpHintLabel,
      placeHolder,
    } = this.props;

    const labelWithOptional = (
      <>
        {translations("label")}
        <br />
        <Message id="feedback.form.optional" />
      </>
    );

    return (
      <FormRow
        label={!required ? labelWithOptional : translations("label")}
        labelFor={id}
        labelId={id}
        required={required}
        hint={
          popUpHintLabel && (
            <PopupHint>
              <Message id={popUpHintLabel} />
            </PopupHint>
          )
        }
      >
        <ValidInput
          id={id}
          name={id}
          value={value}
          onChange={(_e, val) => handleOnChange(val)}
          onBlur={handleOnBlur}
          invalid={!!error}
          autosize
          rows={rows}
          maxRows={maxRows}
          counter={counter}
          maxLength={maxLength}
          required={required}
          aria-describedby={describedBy}
          aria-required={required}
          error={!!error ? this.resolveError(error, translations) : null}
          placeholder={placeHolder}
        />
      </FormRow>
    );
  }

  resolveError = (error, translations) => {
    if (error.code === INVALID_TEXT_AREA_ERROR_CODE) {
      return <InvalidError />;
    } else if (error.code === EMPTY_ERROR_CODE) {
      return translations("error.empty");
    } else {
      return null;
    }
  };
}

TextArea.propTypes = {
  id: PropTypes.string.isRequired,
  translations: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  rows: PropTypes.number.isRequired,
  maxRows: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func,
  required: PropTypes.bool.isRequired,
  counter: PropTypes.bool,
  describedBy: PropTypes.string,
  // Will be passing id as string
  popUpHintLabel: PropTypes.string,
  placeHolder: PropTypes.string,
};

export default TextArea;
